import React, { useRef, useEffect, useState } from 'react';
import { Card, CardBody, CardFooter, CardHeader } from "../../../_metronic/_partials/controls/Card";
import { toAbsoluteUrl } from "../../../_metronic/_helpers/AssetsHelpers";

export function RecapEmail(props) {
    const htmlFilePath = toAbsoluteUrl('/media/email.html');
    const iFrame = useRef(null);
    const [iframeSrc, setIframeSrc] = useState('');

    useEffect(() => {
        loadEmailTemplate();
    }, []);

    const loadEmailTemplate = async () => {
        try {
            // 1. Fetch the HTML file
            const response = await fetch(htmlFilePath);
            const html = await response.text();
            
            // 2. Embed data in HTML
            const modifiedHtml = html.replace(
                '<body',
                `<body data-facility="${props.facility.facilityName}" data-residents="${Array.isArray(props.residentList) ? props.residentList.join(',') : props.residentList}"`
            );
            
            // 3. Create blob URL - THIS IS THE KEY LINE
            const blob = new Blob([modifiedHtml], { type: 'text/html' });
            const blobUrl = URL.createObjectURL(blob);  // ← Creates blob:http://... URL
            
            // 4. Use blob URL in iframe
            setIframeSrc(blobUrl);
        } catch (error) {
            console.error('Error loading email template:', error);
            // Fallback to original method
            setIframeSrc(`${htmlFilePath}?facilityName=${props.facility.facilityName}&residents=${props.residentList}`);
        }
    };

    return (
        <Card className="example example-compact">
            <CardHeader title={'Post Visit Recap - ' + props.facility.facilityName} >
                <div className="card-toolbar">
                    <div className="example-tools">
                        <button type="button" className="mr-5 btn btn-dark btn-sm" onClick={() => props.backPress()}>
                            Back To Facility
                        </button>
                    </div>
                </div>
            </CardHeader>
            <CardBody>
                <div>
                    <iframe
                        ref={iFrame}
                        title="HTML Viewer"
                        src={iframeSrc}  // ← This will be the blob URL
                        style={{ width: '100%', height: '600px', border: 'none' }}>
                    </iframe>
                </div>
            </CardBody>
        </Card>
    );
}

export default RecapEmail;